import React from "react"

function IconMenuStatusAway({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="menu-status-away"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-menu-status-away"
      {...props}
    >
      <path
        d="M6.156 12.714a.9.9 0 0 1 .113 1.793l-.113.007H1.991a.9.9 0 0 1-.113-1.793l.113-.007h4.165zm14.4-6.03a.9.9 0 0 1 .113 1.793l-.113.007H1.991a.9.9 0 0 1-.113-1.793l.113-.007h18.565zm0-6.03a.9.9 0 0 1 .113 1.793l-.113.007H1.991A.9.9 0 0 1 1.878.66L1.99.654h18.565z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M21.508 17.163a6.254 6.254 0 1 1-12.508 0 6.254 6.254 0 0 1 12.508 0"
        fill={color2 || color}
        style={{ height: height || fontSize }}
        originalclass="__warning"
      />
      <path
        d="M16.078 14.936a.896.896 0 0 0-1.793 0v2.237c0 .285.135.553.364.722l2.736 2.017a.896.896 0 1 0 1.064-1.443l-2.371-1.749v-1.784z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  )
}

export default IconMenuStatusAway
